import { defineStore } from 'pinia'
import { ref } from 'vue'
import { checkIsSuperAdmin } from '@/services/admin'

export const useSuperAdminStore = defineStore('superAdmin', () => {
  const isSuperAdmin = ref(null)
  const checked = ref(false)

  async function ensureChecked() {
    if (checked.value) return isSuperAdmin.value
    isSuperAdmin.value = await checkIsSuperAdmin()
    checked.value = true
    return isSuperAdmin.value
  }

  function reset() {
    isSuperAdmin.value = null
    checked.value = false
  }

  return { isSuperAdmin, checked, ensureChecked, reset }
})
